export const COLLAPSED_SQUAD_ROWS = 5;

// The first five members, with the viewer pulled into the fifth slot when they sit further down.
export function visibleSquadRows(rows, isMine, expanded) {
  if (expanded || rows.length <= COLLAPSED_SQUAD_ROWS) return rows;
  const mineIndex = rows.findIndex(isMine);
  if (mineIndex < COLLAPSED_SQUAD_ROWS) return rows.slice(0, COLLAPSED_SQUAD_ROWS);
  return rows.slice(0, COLLAPSED_SQUAD_ROWS - 1).concat([rows[mineIndex]]);
}

export function cropFromRow(row) {
  if (!row) return { scale: 1, x: 0, y: 0 };
  return {
    scale: Number(row.cover_scale != null ? row.cover_scale : row.coverScale) || 1,
    x: Number(row.cover_x != null ? row.cover_x : row.coverX) || 0,
    y: Number(row.cover_y != null ? row.cover_y : row.coverY) || 0,
  };
}

// Where the cover photo sits inside its frame for a crop: the image is scaled to cover the
// frame, then by the crop's scale, and offset in frame widths and heights from the centre.
export function placeCover(frame, image, crop) {
  if (!frame.w || !frame.h || !image.w || !image.h) return null;
  const fit = Math.max(frame.w / image.w, frame.h / image.h);
  const width = Math.ceil(image.w * fit * crop.scale);
  const height = Math.ceil(image.h * fit * crop.scale);
  return {
    width,
    height,
    left: (frame.w - width) / 2 + crop.x * frame.w,
    top: (frame.h - height) / 2 + crop.y * frame.h,
  };
}

export function memberRoleLabel(member) {
  if (member.is_owner || member.isOwner) return 'Owner';
  return member.role === 'admin' ? 'Admin' : 'Member';
}

export function winsLabel(row) {
  const wins = Number(row.wins) || 0;
  return `${wins} ${wins === 1 ? 'win' : 'wins'}`;
}
